import React from 'react'
import _ from 'underscore'
import { Button } from '@/components/ui/button'
import LessonOrder from '../lesson_order/show'
import store from '../../../../../state/store'

class LessonOrders extends React.Component {

  onCreateOrder = () => {
    store.emit('lesson_plan:lesson_order:create', this.props.lesson_plan.id)
  }

  render() {
    const lessonOrders = this.props.lesson_plan.lesson_orders

    if (!lessonOrders) {
      return null
    }

    return (
      <React.Fragment>
        {_.map(lessonOrders, (lesson_order) => {
          return (
            <LessonOrder
              key={lesson_order.id}
              lesson_plan={this.props.lesson_plan}
              lesson_order={lesson_order}
              pricing_calculator={this.props.pricing_calculator}
              change_applied={this.props.change_applied}
            />
          )
        })}
        {(!_.any(lessonOrders)) ?
          <div className="text-center">
            <Button size="sm" onClick={this.onCreateOrder}>Create Lesson Order</Button>
          </div>
          : null
        }
      </React.Fragment>
    )
  }
}
         
export default LessonOrders
